module.exports = __webpack_public_path__ + "img/icono-13-1.c7b37b77.png";